import React, { useEffect, useState } from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { FaFilePdf,FaLink } from 'react-icons/fa';

import api from '../../../Services/api';
import { GoDownload } from "react-icons/go";
import { FaFileDownload } from "react-icons/fa";
import { MdFileOpen,MdEdit, MdRemoveRedEye, MdDelete, MdEditDocument } from "react-icons/md";

const HolidayListTable = ({ isAdmin = false, onEditHoliday , triggerSnackbar}) => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedYear, setSelectedYear] = useState('2025');
  const [holidayList, setHolidayList] = useState([]);
  const[loading,setLoading] = useState(true);
  

  const getAllStates = async () => {
    try {
      const response = await api.minimumWages.getMinimumWagesAllStates();
      if (response.status === 200) {
        setStates(response.data.states);
      } else {
        console.error('Error fetching states');
      }
    } catch (error) {
      console.error('Error fetching states', error);
    }
  };

  const getHolidayListByStateAndYear = async (selectedState, selectedYear) => {
  setLoading(true);
  try {
    const response = await api.HolidayList.getHolidayListByStateAndYear(selectedState, selectedYear);
    if (response.status === 200) {
      const holidayData = response.data.HolidayList;
      setHolidayList(Array.isArray(holidayData) ? holidayData : [holidayData]);
    } else {
      setHolidayList([]);
    }
  } catch (error) {
    console.error('Error fetching holiday list', error);
    setHolidayList([]);
  }
  finally {
    setTimeout(() => setLoading(false), 1000);
  }
};


  const getOneYearHolidayListOfAllStates = async (year) => {
  setLoading(true);
  try {
    const response = await api.HolidayList.getOneYearListOfAllStates(year);
    if (response.status === 200) {
      const holidayData = response.data.yearlyList;
      setHolidayList(Array.isArray(holidayData) ? holidayData : [holidayData]);
    } else {
      setHolidayList([]);
    }
  } catch (err) {
    console.error("Error fetching holiday list for all states", err);
    setHolidayList([]);
  }
  finally {
  setTimeout(() => setLoading(false), 1000);
}

};

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const deleteHolidayList = async (id) => {
    if (!isAdmin) return;
    try {
      const response = await api.HolidayList.deleteHolidayList(id);
      if (response.status === 200) {
        setHolidayList(holidayList.filter((holiday) => holiday.id !== id));
        triggerSnackbar('success',response.data?.message)
        
      } else if (response.status === 400 || response.status === 404) {
        triggerSnackbar('error',response.data?.message)
      }else if (response.status ===  500) {
        triggerSnackbar('error',response.data?.message)
      }
    } catch (error) {
      console.error('Error deleting holiday list', error);
    }
  };

  useEffect(() => {
    getAllStates();
    setLoading(true)
    getOneYearHolidayListOfAllStates(selectedYear); 
  }, []);

  useEffect(() => {
  if (!selectedYear) return;

  (async () => {
    if (selectedState && selectedYear) {
      await getHolidayListByStateAndYear(selectedState, selectedYear);
    } else {
      await getOneYearHolidayListOfAllStates(selectedYear);
    }
  })();
}, [selectedState, selectedYear]);


  return (
    <div className='rounded-lg border bg-card text-card-foreground shadow-2xs mt-10'>
      <div className='flex flex-col space-y-1.5 p-6'>
        <h1 className='text-xl text-danger font-semibold leading-none tracking-tight'>Uploaded Documents</h1>

        <div className='flex flex-row justify-end align-middle gap-2 p-6'>
          <div className='space-y-2'>
            <select
              className='w-full p-2 border border-gray-300 rounded-md'
              value={selectedState}
              onChange={(e) => setSelectedState(e.target.value)}
            >
              <option value=''>Select State</option>
              {states.map((state) => (
                <option key={state.StateId} value={state.State}>
                  {state.State}
                </option>
              ))}
            </select>
          </div>

          <div className='space-y-2'>
            <select
              className='w-full p-2 border border-gray-300 rounded-md'
              value={selectedYear}
              onChange={handleYearChange}
            >
              <option value='' disabled>
                Select Year
              </option>
              <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
              <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
              <option value={new Date().getFullYear() + 1}>{new Date().getFullYear() + 1}</option>
            </select>
          </div>
        </div>

        {loading ? (
            <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
              <h3>Loading</h3>
              <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
              <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
              <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem', marginLeft: '10px' }} role="status"></div>
            </div>
          ) : (
            <div className="border rounded-md overflow-hidden">
              <div className="max-h-[300px] overflow-y-auto">
                <table className="min-w-full border-collapse">
                  <thead className="sticky top-0 z-10 bg-black">
                    <tr>
                      <th className="p-2 text-center border-0 text-white">Sl.No</th>
                      <th className="p-2 text-center border-0 text-white">Uploaded On</th>
                      <th className="p-2 text-center border-0 text-white">State</th>
                      <th className="p-2 text-center border-0 text-white">Year</th>
                      <th className="p-2 text-center border-0 text-white">Document</th>

                      <th className="p-2 text-center border-0 text-white">Reference Link</th>
                      {isAdmin && (
                        <th className="p-2 text-center border-0 text-white">Actions</th>
                      )}
                    </tr>
                  </thead>

                  <tbody>
                    {holidayList.length > 0 ? (
                      holidayList.map((holiday, index) =>
                        holiday && holiday.State ? (
                          <tr key={index}>
                            <td className=" border-none text-center">{index + 1}</td>
                            <td className="border-none text-center">
                              {new Date(holiday.createdAt).toLocaleDateString("en-GB")}
                            </td>
                            <td className="border-none text-center">{holiday.State}</td>
                            <td className=" border-none text-center">{holiday.year}</td>
                   
                            <td className="border-none text-center">
                              {holiday.FileUrl && holiday.FileUrl !== "N/A" ? (
                                <div className='d-flex justify-content-center gap-2'>
                                <a
                                  href={`https://docs.google.com/gview?url=${holiday.FileUrl}&embedded=true`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex gap-1 items-center px-1 py-1 text-sm"
                                >
                    <MdFileOpen className="text-lg text-green-600" />
                     <span>View</span>
                                    </a>
                                  <a
                                    href={holiday.FileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    download
                                    className="flex gap-2 items-center px-1 py-1 text-sm"
                                    title="Download document"
                                  >
  <FaFileDownload className="text-base text-blue-600" />
                    <span>Download</span>
                                  </a>
                               </div>
                              ) : (
                                "N/A"
                              )}
                            </td>
                                     <td className=" border-none text-center">
                              {holiday.ReferenceLink && holiday.ReferenceLink !== "N/A" ? (
                                <a
                                  href={holiday.ReferenceLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="flex items-center gap-1 justify-center hover:underline text-primary-color"
                                  title="Click to view link"
                                >
                          <FaLink className="text-red-600 hover:text-red-800" />

                                </a>
                              ) : (
                                "N/A"
                              )}
                            </td>
                            {isAdmin && (
                              <td className="border-none text-center flex justify-center gap-2">
                                <button
                                  className="px-1 py-1 border border-gray-400 rounded hover:bg-gray-100"
                                  title="Edit"
                                  onClick={() => {
                                    onEditHoliday(holiday);
                                    window.scrollTo({ top: 0, behavior: "smooth" });
                                  }}
                                >
                                  <MdEditDocument className="text-lg text-blue-600" />
                                </button>
                                <button
                                  className="px-1 py-1 border border-gray-400 rounded hover:bg-gray-100"
                                  title="Delete"
                                  onClick={() => deleteHolidayList(holiday.id)}
                                >
                                  <MdDelete className="text-lg text-red-600"  />
                                </button>
                              </td>
                            )}
                          </tr>
                        ) : null
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={isAdmin ? 7 : 6}
                          className="p-4 text-center text-gray-500"
                        >
                          No holiday list found for the selected filters.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

          )}
      </div>
    </div>
  );
};

export default HolidayListTable;
